import { Component } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

import { AuthenticationService } from "../../common/authentication/authentication.service";
import { ValidationService } from "../../common/validation/validation.service";
import { ResetPasswordFormValue } from "../../models";
import { TranslateService } from "../../common/translate/translate.service";
import { SnackbarService } from "../../common/snackbar/snackbar.service";

@Component({
	selector: "sdp-reset-password",
	templateUrl: "./reset-password.component.html",
})

export class ResetPasswordComponent {
	public resetPasswordForm: FormGroup;
	public passwordType = "password";
	public readonly passwordIcon = { type: "material", name: "remove_red_eye", cssClass: "sdp-password-show-icon" };

	private _isResetting = false;

	constructor(
		private formBuilder: FormBuilder,
		private auth: AuthenticationService,
		private validationService: ValidationService,
		private translateService: TranslateService,
		private snackbarService: SnackbarService
	) {
		this.resetPasswordForm = this.formBuilder.group({
			currentPassword: [
				"",
				Validators.required
			],
			password: [
				"",
				Validators.compose([
					Validators.required,
					Validators.minLength(8),
					this.validationService.createConfirmPasswordValidatorForPassword("password", "confirmPassword")
				])
			],
			confirmPassword: [
				"",
				this.validationService.createConfirmPasswordValidatorForConfirmPassword("password", "confirmPassword")
			]
		});
	}

	public get isDoingWork() {
		return this._isResetting;
	}

	public async submit() {
		if (this.resetPasswordForm.valid) {
			this._isResetting = true;
			try {
				await this.auth.resetPassword(<ResetPasswordFormValue>this.resetPasswordForm.getRawValue());
				// reset form and remove any errors
				for (const name in this.resetPasswordForm.controls) {
					if (this.resetPasswordForm.controls.hasOwnProperty(name)) {
						this.resetPasswordForm.controls[name].setValue("");
						/* tslint:disable-next-line:no-null-keyword */
						this.resetPasswordForm.controls[name].setErrors(null);
					}
				}
				this.snackbarService.open(this.translateService.translate("resetpassword.success"));
			} catch (e) {
				this.snackbarService.open(this.translateService.translate(e));
			} finally {
				this._isResetting = false;
			}
		}
	}
}
